import { useEffect, useState } from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { listCamerasWithSensors } from '../services/cameraService';
import CameraGallery from '../components/live/CameraGallery';
import LivePlayer from '../components/live/LivePlayer';
import ConnectedReadingsPanel from '../components/live/ConnectedReadingsPanel';

export default function LiveViewerPage() {
  const [cameras, setCameras] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    listCamerasWithSensors().then(setCameras).catch(() => setCameras([]));
  }, []);

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" sx={{ mb: 3 }}>Live</Typography>
      {cameras.length === 0 ? (
        <Typography color="text.secondary">No cameras yet. Add one and link it to a sensor.</Typography>
      ) : (
        <>
          <CameraGallery cameras={cameras} selectedId={selected?.id ?? null} onSelect={setSelected} />
          {selected && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={8}><LivePlayer cameraId={selected.id} /></Grid>
              <Grid item xs={12} md={4}>
                <Box><ConnectedReadingsPanel sensors={selected.connectedSensors} /></Box>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </Container>
  );
}
